export const getInitialBooleanValue = <T = unknown>(value: T, defaultValue: T): T => {
    if (typeof value === 'undefined') {
        return defaultValue
    }
    return value
}